import { render, staticRenderFns } from "./examinationPaper.vue?vue&type=template&id=fd105f94&scoped=true"
import script from "./examinationPaper.vue?vue&type=script&lang=js"
export * from "./examinationPaper.vue?vue&type=script&lang=js"
import style0 from "./examinationPaper.vue?vue&type=style&index=0&id=fd105f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd105f94",
  null
  
)

export default component.exports